import { useCallback } from 'react';
import { IStopLoadingHandler } from './interfaces';

export const StopLoadingHandler = (data: IStopLoadingHandler) => {
  const { setIsLoading } = data;
  return useCallback(() => {
    setIsLoading(false);
  }, [setIsLoading]);
};
